import type { IPinfo } from "node-ipinfo";
import { createContext } from "react";

export const IPinfoContext = createContext<IPinfo | null>(null);
